import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Chip,
  IconButton,
  Divider,
  Grid,
  Input,
  FormHelperText,
  TextField,
  Avatar,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import FileUploadIcon from "@mui/icons-material/FileUpload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import GridOnIcon from "@mui/icons-material/GridOn";
import TableChartIcon from "@mui/icons-material/TableChart";

import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { ArrowBack, UploadFile } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { enqueueSnackbar } from "notistack";
import { useIds } from "../../hook/AdminContext";
import {
  apply_job_api,
  favourite_live_job_api,
  get_hr_blog_etail_api,
  get_live_job_feed_etail_api,
  upload_image_documents_on_s3,
} from "../../DAL/partner/partners";
import PageLoading from "../../components/loader/PageLoading";
import {
  formatEducationRequired,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import { s3baseUri } from "../../config/config";

export default function JobDetailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const job = location.state?.job || {};
  const [bookmarked, setBookmarked] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [loading, setLoading] = useState(true);
  const [result_application, set_result_application] = useState({});

  const [cvName, setCvName] = useState(""); // State to store CV file name
  const [cv, setcv] = useState(); // State to store CV file name
  const [shortDescription, setShortDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // for apply action

  const { findId, setBreadCrumb, userInfo } = useIds();
  const [dataapi, setDataApi] = useState();
  const params = useParams();
  console.log(params, "paramsparamsparams");
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [files, setFiles] = useState([]);

  console.log(location, "loclocloclcolcoclcoo");
  const handleCvNull = () => {
    setcv(null);
    setCvName(null);
  };

  const Job_by_state = location?.state?.job;
  const firstSegment = location.pathname.split("/")[1];
  const fetchCategories = async () => {
    setLoading(true);
    const response = await get_live_job_feed_etail_api(params.id);
    console.log(response, "responseresponseresponseresponse");
    if (response.code === 200) {
      setDataApi(response.job);
      set_result_application(response?.result_application);
      // navigate(-1);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchCategories();
  }, []);
  const handleBookmarkToggle = (jobId) => {
    console.log(jobId, "jobIdjobIdjobIdjobId");

    const newBookmarkedState = !bookmarkedJobs[jobId]; // Toggle state optimistically

    setBookmarkedJobs((prev) => {
      const updatedBookmarks = { ...prev, [jobId]: newBookmarkedState };
      localStorage.setItem("bookmarkedJobs", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        console.log("API Response:", response);

        // Check if the API returns a specific message
        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        // Revert state in case of API failure
        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };
  const getFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();

    switch (extension) {
      case "pdf":
        return <PictureAsPdfIcon color="error" fontSize="large" />;
      case "doc":
      case "docx":
        return <DescriptionIcon color="primary" fontSize="large" />;
      case "xls":
      case "xlsx":
        return <GridOnIcon color="success" fontSize="large" />;
      case "csv":
        return <TableChartIcon color="action" fontSize="large" />;
      default:
        return <InsertDriveFileIcon color="disabled" fontSize="large" />;
    }
  };
  const handleDownloadAdditiondOC = async (documentPath) => {
    const fileUrl = `${s3baseUri}${documentPath}`;
    const filename = documentPath.split("/").pop();

    try {
      const response = await fetch(fileUrl, { mode: "cors" });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download error:", error);
    } finally {
    }
  };

  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);
  const removeFile = (indexToRemove) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove)
    );
  };

  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setcv(file);
    if (file) {
      setCvName(file.name);
    }
  };
  const handleFileChangeAdditional = (e) => {
    const selectedFiles = Array.from(e.target.files);

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
      "image/jpeg", // for .jpg and .jpeg
      "image/png", // for .png
    ];

    const validFiles = selectedFiles.filter((file) =>
      allowedTypes.includes(file.type)
    );

    if (validFiles.length !== selectedFiles.length) {
      enqueueSnackbar(
        "Only PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, and PNG files are allowed",
        { variant: "error" }
      );
    }

    const maxFiles = 5;
    if (files.length + validFiles.length > maxFiles) {
      enqueueSnackbar("You can only upload up to 5 documents.", {
        variant: "error",
      });
      return;
    }

    setFiles((prev) => [...prev, ...validFiles]);
    e.target.value = null;
  };
  const HandleApplyJob = async () => {
    if (!cv) {
      enqueueSnackbar("Please attach your CV before applying!", {
        variant: "error",
      });
      return;
    }

    const newcv = cvName.toLowerCase();
    const allowedExtensions = [".pdf", ".doc", ".docx"];

    // Check if the file has a valid extension
    if (!allowedExtensions.some((ext) => newcv.endsWith(ext))) {
      enqueueSnackbar("Only PDF, DOC, and DOCX files are accepted!", {
        variant: "error",
      });
      return;
    }

    setIsSubmitting(true);
    let uploadedFiles = [];
    for (let file of files) {
      const formData = new FormData();
      formData.append("image", file);
      try {
        const res = await upload_image_documents_on_s3(formData);
        if (res.code === 200) {
          uploadedFiles.push(res.image_path);
        }
      } catch (err) {
        enqueueSnackbar(`Failed to upload ${file.name}`, { variant: "error" });
      }
    }

    let data = {
      Job_id: params.jobId,
      cv: cvName,
      job_description: shortDescription,
    };
    const formData = new FormData();
    formData.append("Job_id", params.id);
    formData.append("cv", cv);
    formData.append("job_description", shortDescription);
    // formData.append("description", inputs.description);

    console.log(formData, "formDataformDataformData");

    const response = await apply_job_api(formData);
    console.log(response, "responseresponseresponseresponse");
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setLoading(false);
      setIsSubmitting(false);

      navigate(-1);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsSubmitting(false);
    }
  };
  let icon = {
    iconBg: "#000080",
  };
  const navigeBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Live Job Feed`,
        path: `/${firstSegment}/live-job-feed`,
        active: false,
      },
      {
        name: `Live Job Feed Detail`,
        path: "",
        active: true,
      },
    ]);
  }, []);

  const salaryFrequency = (type) => {
    switch (type) {
      case "Monthly":
        return "month";
      case "Yearly":
        return "year";
      case "Anually":
        return "annually";
      case "Weekly":
        return "week";
      case "Daily":
        return "day";
      case "Hourly":
        return "hour";
      default:
        return "";
    }
  };
  let login_nfo = localStorage.getItem("user");

  let user_info = login_nfo ? JSON.parse(login_nfo) : null; // Safely parse JSON if data exists
  console.log(user_info, "Parsed user_info");
  useEffect(() => {
    if (Job_by_state.created_by_me && result_application) {
      setShortDescription(result_application.job_description);
      setCvName(result_application.cv);

      // Additional documents
      if (result_application?.additional_documents) {
        // Assuming additional_documents is an array of file names or URLs
        setFiles(
          result_application?.additional_documents.map((doc) => ({
            name: doc,
            url: s3baseUri + doc,
          }))
        );
      }
    }
  }, [result_application]);

  if (loading) {
    return <PageLoading />;
  }
  return (
    <Box sx={{ mx: "auto", mt: 1, p: { xs: 1, md: 3 }, pb: 12 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{ xs: "row", sm: "row" }}
        gap={2}
      >
        {/* Profile Avatar and Info */}
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar
            src={s3baseUri + job?.creater_info?.profile_image}
            alt=""
            sx={{
              width: 45,
              height: 45,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <Box>
            <Typography variant="h6" fontWeight="bold">
              {dataapi?.jobTitle}
            </Typography>
            <Typography
              variant="body1"
              color="textSecondary"
              sx={{ fontSize: "13px" }}
            >
              {dataapi?.location}
            </Typography>
          </Box>
        </Box>

        {/* Bookmark Icon */}
        {userInfo?.type === 1 && (
          <IconButton
            onClick={() => handleBookmarkToggle(job._id)}
            sx={{ alignSelf: { xs: "flex-start", sm: "center" } }}
          >
            {bookmarkedJobs[job._id] ? (
              <BookmarkIcon sx={{ color: "#000080" }} />
            ) : (
              <BookmarkBorderIcon />
            )}
          </IconButton>
        )}
      </Box>
      <Divider sx={{ my: 2 }} />
      {/* Job Info Grid */}
      <Grid container spacing={2}>
        {[
          { title: "Job Type", value: dataapi?.jobType },
          {
            title: "Experience",
            value: show_des_data(dataapi?.experienceRequired),
          },
          // Salary block
          ...(dataapi?.salaryType === "fixed"
            ? [
                {
                  title: "Fixed Salary",
                  value: dataapi?.salary
                    ? `€${dataapi?.salary}/${salaryFrequency(
                        dataapi?.frequencySalary
                      )}`
                    : "N/A",
                },
              ]
            : [
                {
                  title: "Max Salary",
                  value: dataapi?.maxSalary
                    ? `€${dataapi?.maxSalary}/${salaryFrequency(
                        dataapi?.frequencySalary
                      )}`
                    : "N/A",
                },
                ...(dataapi?.minSalary
                  ? [
                      {
                        title: "Min Salary",
                        value: `€${dataapi?.minSalary}/${salaryFrequency(
                          dataapi?.frequencySalary
                        )}`,
                      },
                    ]
                  : []),
              ]),
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Typography variant="h6" fontWeight="bold">
              {item.title}
            </Typography>
            <Typography
              variant="body1"
              sx={{ mt: 1, fontSize: "16px", lineHeight: "1.6" }}
            >
              {item.value}
            </Typography>
          </Grid>
        ))}
      </Grid>
      {/* Education and Description */}
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }}>
        Education
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        {formatEducationRequired(dataapi?.educationRequired)}
      </Typography>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 2 }}>
        Job Description
      </Typography>
      <Typography
        variant="body1"
        sx={{ mt: 2, fontSize: "15px" }}
        dangerouslySetInnerHTML={{ __html: dataapi?.description }}
      />
      {/* Upload Section for Other Users */}
      {job.created_by !== user_info?.user_id?._id && userInfo?.type === 1 && (
        <>
          {/* CV Section with Tooltip */}

          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", sm: "center" },
                mt: 4,
                gap: 2,
              }}
            >
              <Box>
                <Typography variant="h6" fontWeight="bold">
                  Upload CV *
                </Typography>
                <FormHelperText sx={{ fontSize: "14px", color: "gray" }}>
                  Accepted File types: pdf, docx, doc
                </FormHelperText>
              </Box>

              {(cvName ||
                (Job_by_state.created_by_me && result_application?.cv)) && (
                <Tooltip
                  title={
                    Job_by_state.created_by_me && result_application?.cv
                      ? "Click to download your uploaded CV"
                      : ""
                  }
                  arrow
                  disableHoverListener={
                    !(Job_by_state.created_by_me && result_application?.cv)
                  }
                >
                  <Box
                    sx={{
                      position: "relative",
                      border: "1px solid silver",
                      borderRadius: "5px",
                      p: 1,
                      mt: { xs: 1, sm: 0 },
                      display: "flex",
                      alignItems: "center",
                      width: Job_by_state.created_by_me ? "52px" : "200px",

                      marginRight: Job_by_state.created_by_me
                        ? "300px"
                        : "130px",
                      gap: 1,
                      cursor: Job_by_state.created_by_me
                        ? "pointer"
                        : "default",
                      "&:hover": {
                        backgroundColor: Job_by_state.created_by_me
                          ? "#f5f5f5"
                          : "inherit",
                      },
                    }}
                    onClick={(e) => {
                      if (
                        Job_by_state.created_by_me &&
                        result_application?.cv
                      ) {
                        e.stopPropagation();
                        // Construct proper download URL
                        const cvUrl = `${s3baseUri}${result_application.cv}`;
                        console.log("Attempting to download CV from:", cvUrl); // Debug log
                        window.open(cvUrl, "_blank", "noopener,noreferrer");
                      }
                    }}
                  >
                    {getFileIcon(
                      cvName || result_application?.cv.split("/").pop()
                    )}
                    {!Job_by_state.created_by_me && (
                      <Typography sx={{ fontSize: "13px" }}>
                        {cvName || result_application?.cv.split("/").pop()}
                      </Typography>
                    )}
                    {!Job_by_state.created_by_me && (
                      <IconButton
                        size="small"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          right: "-5px",
                          backgroundColor: "red",
                          color: "white",
                          padding: "1px",
                          "&:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCvNull();
                        }}
                      >
                        <CloseIcon sx={{ fontSize: "15px" }} />
                      </IconButton>
                    )}
                  </Box>
                </Tooltip>
              )}

              {!Job_by_state.created_by_me ? (
                <Box>
                  <label
                    className="small-button-job-live"
                    htmlFor="image-upload"
                  >
                    <UploadFile />
                    Upload CV
                  </label>
                  <input
                    accept=".pdf,.doc,.docx"
                    id="image-upload"
                    type="file"
                    hidden
                    onChange={handleFileChange}
                  />
                </Box>
              ) : (
                <Box></Box>
              )}
            </Box>
          </Box>
        </>
      )}
      {userInfo?.type === 1 && (
        <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
      )}

      {job.created_by !== user_info?.user_id?._id && userInfo?.type === 1 && (
        <>
          {/* Additional Documents Section with Tooltip */}

          <Box>
            <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
              <div className="row w-100 div-style ms-0 pt-0">
                <div className="col-lg-5 col-md-5 col-sm-12 p-0">
                  <Typography variant="h6" fontWeight="bold">
                    Additional documents
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "normal",
                        marginLeft: "5px",
                      }}
                    >
                      (You can upload up to 5 documents)
                    </span>
                  </Typography>
                  <FormHelperText sx={{ fontSize: "14px", color: "gray" }}>
                    Allowed formats: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG | Max
                    size: 200 MB
                  </FormHelperText>
                </div>

                <div className="col-lg-2 col-md-2 col-12">
                  {(files.length > 0 ||
                    (Job_by_state.created_by_me &&
                      result_application?.additional_documents?.length >
                        0)) && (
                    <>
                      {/* Files uploaded by applicant (show remove icon) */}
                      <></>

                      {!Job_by_state.created_by_me &&
                        files.length > 0 &&
                        files.map((file, index) => (
                          <Box
                            key={index}
                            sx={{
                              position: "relative",
                              border: "1px solid silver",
                              borderRadius: "5px",
                              p: 1,
                              mt: 1,
                              mb: 1,
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 1,
                              mr: 1,
                            }}
                          >
                            {getFileIcon(file.name)}
                            <Typography sx={{ fontSize: "13px" }}>
                              {file.name}
                            </Typography>
                            <IconButton
                              size="small"
                              sx={{
                                position: "absolute",
                                top: "-10px",
                                right: "-5px",
                                backgroundColor: "red",
                                color: "white",
                                padding: "1px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFile(index);
                              }}
                            >
                              <CloseIcon sx={{ fontSize: "15px" }} />
                            </IconButton>
                          </Box>
                        ))}

                      {/* Files uploaded by creator (no remove icon) */}
                      {Job_by_state.created_by_me &&
                        result_application?.additional_documents?.map(
                          (doc, index) => (
                            <Tooltip
                              title={
                                Job_by_state.created_by_me &&
                                result_application?.additional_documents
                                  ?.length > 0
                                  ? "Click to download documents"
                                  : ""
                              }
                              arrow
                              disableHoverListener={
                                !(
                                  Job_by_state.created_by_me &&
                                  result_application?.additional_documents
                                    ?.length > 0
                                )
                              }
                            >
                              <Box
                                key={`prefilled-${index}`}
                                sx={{
                                  position: "relative",
                                  border: "1px solid silver",
                                  borderRadius: "5px",
                                  p: 1,
                                  mt: 1,
                                  mb: 1,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 1,
                                  mr: 1,
                                  cursor: "pointer",
                                  "&:hover": {
                                    backgroundColor: "#f5f5f5",
                                  },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDownloadAdditiondOC(doc);
                                }}
                              >
                                {getFileIcon(doc.split("/").pop())}
                                {!Job_by_state.created_by_me && (
                                  <Typography sx={{ fontSize: "13px" }}>
                                    {doc.split("/").pop()}
                                  </Typography>
                                )}
                              </Box>
                            </Tooltip>
                          )
                        )}
                    </>
                  )}
                </div>

                {!Job_by_state.created_by_me && (
                  <div className="col-lg-5 col-md-5 col-6 text-start text-md-end pt-2 p-0">
                    <label htmlFor="upload-file">
                      <input
                        type="file"
                        id="upload-file"
                        name="documents"
                        multiple
                        accept=".pdf,.doc,.docx,.xlsx,.xls,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAdditional}
                        style={{ display: "none" }}
                      />

                      <Button
                        startIcon={<FileUploadIcon />}
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "15px",
                          fontFamily: "Montserrat !important",
                        }}
                        className="small-contained-button-field"
                        component="span"
                      >
                        {uploading ? (
                          <CircularProgress
                            size={16}
                            sx={{ color: "white", mr: 1 }}
                          />
                        ) : (
                          "Upload"
                        )}
                      </Button>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </Box>
        </>
      )}
      {userInfo?.type === 1 && (
        <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
      )}
      <Box>
        {userInfo?.type === 1 && (
          <>
            <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }}>
              Short Description
            </Typography>
            <Tooltip
              title={
                Job_by_state.created_by_me &&
                result_application?.job_description
                  ? "This is your uploaded description. You cannot edit it."
                  : ""
              }
              arrow
            >
              <Box>
                <TextField
                  fullWidth
                  multiline
                  rows={6}
                  placeholder={
                    Job_by_state.created_by_me
                      ? ""
                      : "Enter a brief description about yourself"
                  }
                  value={
                    Job_by_state.created_by_me
                      ? result_application?.job_description || shortDescription
                      : shortDescription
                  }
                  disabled={Job_by_state.created_by_me}
                  onChange={(e) =>
                    !Job_by_state.created_by_me &&
                    setShortDescription(e.target.value)
                  }
                  sx={{ mt: 1 }}
                />
              </Box>
            </Tooltip>
          </>
        )}
      </Box>
      {/* Apply Button */}
      <Box display="flex" justifyContent="end" mt={2}>
        {job.created_by !== user_info?.user_id?._id &&
          !Job_by_state.created_by_me &&
          userInfo?.type === 1 && (
            <Button
              onClick={HandleApplyJob}
              sx={{
                textTransform: "capitalize",
                fontFamily: "Montserrat !important",
                boxShadow: "none !important",
              }}
              variant="contained"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <CircularProgress size={20} sx={{ color: "white", mr: 1 }} />
                  Applying...
                </>
              ) : (
                "Apply now"
              )}
            </Button>
          )}
      </Box>
    </Box>
  );
}
